/**
 * This module defines the sub-routing for Submission component.
 * This module will be included and used inside the Router object.
 */

// Entry point to Submission component

const FilmLicenseAgreement = () => import('@/components/Licenses/FilmLicenseAgreementIntro');
const SignupFilmmaker = () => import('./SignupFilmmaker');
const SignupEmail = () => import('./SignupEmail');

export default [
  {
    path: '/signup/',
    component: SignupFilmmaker,
    meta: {
      fullscreen: true,
    },
  }, {
    path: '/signup/agreement/',
    component: FilmLicenseAgreement,
    meta: {
      fullscreen: true,
    },
  }, {
    path: '/signup/email/',
    component: SignupEmail,
    meta: {
      fullscreen: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/Profile/Signup/index.js